import {
  Component,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  EventEmitter,
} from "@angular/core";
import { VoiceRecorder } from "@independo/capacitor-voice-recorder";

@Component({
  selector: "app-voice-input",
  templateUrl: "./voice-input.component.html",
  styleUrls: ["./voice-input.component.scss"],
  standalone: false,
})
export class VoiceInputComponent implements OnInit, OnChanges {
  recording: boolean = false;
  buttonType: string = "vocal";

  progressBarValue: number = 0.0;
  interval: any;
  audioFile: any;
  isRecording = false;
  inPause = false;
  end = false;
  duration = 0;
  audioRef: any;
  isPlaying: boolean = false;
  recordedAudioFilePath: any;
  recordedAudioFileDuration: any = 0;
  recordedAudioFileType: string = "";

  @Output() drop: EventEmitter<any> = new EventEmitter<any>();
  @Output() vocal: EventEmitter<any> = new EventEmitter<any>();
  @Input() start: boolean = false;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes["start"]) {
      if (this.start) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    }
  }
  formatTime(time: any) {
    return time < 0.6 ? time.toString().replace(".", ":") : "1:00";
  }
  sendVoiceMessage() {
    if (this.isPlaying || this.isRecording) {
      this.toggleRecording();
    }
    setTimeout(() => {
      const duration = this.recordedAudioFileDuration - 1000;
      const payload = {
        duration: duration,
        voiceMessage: this.recordedAudioFilePath,
        extension: this.recordedAudioFileType,
      };
      this.vocal.emit(payload);
    }, 500);
    setTimeout(() => {
      this.deleteRecording();
    }, 1000);
  }
  /*****************
   start voice block
   *****************/

  async toggleRecording() {
    if (!this.isRecording && !this.end) {
      this.startRecording();
    } else if (this.isRecording && !this.end) {
      const audioFile = await this.stopRecording();
      if (audioFile) {
        this.recordedAudioFilePath = audioFile;
      } else {
        console.error("No audio file to upload");
      }
    } else {
      if (!this.isPlaying) {
        this.duration = this.progressBarValue;
        this.progressBarValue = 0.0;
        this.startPlayingProgressBar();
        this.playAudio();
      } else if (!this.inPause) {
        this.inPause = true;
        this.audioRef.pause();
      } else {
        this.startPlayingProgressBar();
        this.inPause = false;
        this.audioRef.play();
      }
    }
  }
  async startRecording() {
    this.buttonType = "";
    this.recording = true;
    try {
      const permissionStatus =
        await VoiceRecorder.requestAudioRecordingPermission();
      if (permissionStatus.value) {
        await VoiceRecorder.startRecording();
        this.isRecording = true;
        this.end = false;
        this.startProgressBar();
      } else {
        console.error("Audio recording permission denied");
        this.recording = false;
      }
    } catch (error) {
      console.error("Failed to start recording", error);
      this.recording = false;
    }
  }

  async stopRecording() {
    try {
      const audioFile = await VoiceRecorder.stopRecording();
      this.audioFile = audioFile;
      const recordData = audioFile.value.recordDataBase64?.trim() ?? "";
      this.recordedAudioFileDuration = audioFile.value.msDuration;
      this.recordedAudioFileType = audioFile.value.mimeType
        .split(";")[0]
        .split("/")[1];
      this.isRecording = false;
      this.end = true;
      this.buttonType = "text";
      this.recording = false;
      return recordData;
    } catch (error) {
      console.error("Failed to stop recording", error);
      return null;
    }
  }

  startProgressBar() {
    this.interval = setInterval(() => {
      !this.end && (this.progressBarValue += 0.01);
      if (!this.isRecording || this.progressBarValue > 0.6) {
        clearInterval(this.interval);
      }
    }, 1000);
  }

  startPlayingProgressBar() {
    this.interval = setInterval(() => {
      if (
        !this.isPlaying ||
        this.inPause ||
        Number(this.progressBarValue) >= Number(this.duration)
      ) {
        clearInterval(this.interval);
        Number(this.progressBarValue) >= Number(this.duration) &&
          (this.isPlaying = false);
        return;
      }
      this.isPlaying && (this.progressBarValue += 0.01);
    }, 1000);
  }

  playAudio() {
    if (this.audioFile && !this.isPlaying) {
      const audioFile = this.audioFile.value;
      const base64Sound = audioFile.recordDataBase64;
      const mimeType = audioFile.mimeType;
      const audioRef = new Audio(`data:${mimeType};base64,${base64Sound}`);
      this.audioRef = audioRef;
      audioRef.oncanplaythrough = () => {
        this.isPlaying = true;
        audioRef.play();
      };
      audioRef.load();
    } else {
      if (this.inPause && this.isPlaying) {
        this.audioRef.pause();
      } else {
        this.audioRef.play();
      }
      console.error("no audio recorded to play");
    }
  }

  deleteRecording() {
    this.isPlaying && this.audioRef.pause();
    this.isRecording && this.stopRecording();
    this.drop.emit();
    this.isRecording = false;
    this.inPause = false;
    this.isPlaying = false;
    this.end = false;
    clearInterval(this.interval);
    this.progressBarValue = 0.0;
    this.duration = 0.0;
    this.recordedAudioFilePath = null;
    this.recordedAudioFileDuration = 0;
    this.audioRef = null;
  }

  /*****************
  end voice block
  *****************/
}
